import React, {
  EventHandler,
  KeyboardEvent,
  MouseEvent,
  useCallback,
} from 'react';
import { classNames } from '../../utils/style';
import { Icon } from '../../components/Picto/Icon';
import { PictoName } from '../../components/Picto/pictosLibrary';
import { IllustrationName } from '../../components/Picto/illustrationLibrary';

interface TabLayoutProps {
  selected: boolean;
  title?: string;
  onClick?: EventHandler<MouseEvent | KeyboardEvent>;
  picto?: PictoName | IllustrationName;
  className?: string;
}

export const Tab = ({
  selected = false,
  onClick,
  picto,
  title,
  className,
  ...props
}: TabLayoutProps) => {
  const handleKeyDown = useCallback(
    (event: KeyboardEvent) => {
      if (event.key === 'Enter' && onClick) onClick(event);
    },
    [onClick],
  );

  return (
    <button
      onClick={onClick}
      onKeyDown={handleKeyDown}
      className={classNames(
        'Tab',
        className,
        selected
          ? 'border-white !bg-blue-21 !text-primary-1'
          : 'border-[1px] border-solid !border-[#DFE6ED] bg-white !text-navy-80',
        'rounded-[30px] hover:!border-[#DFE6ED] hover:!bg-blue-21 focus:bg-blue-21',
        'tab flex cursor-pointer flex-row items-center',
        'h-full outline-none',
      )}
    >
      {picto && (
        <div className={classNames('rounded-6', 'mx-[2px] h-20 w-20')}>
          <Icon
            name={picto}
            width={20}
            height={20}
            twTextColor={selected ? 'text-[#0F6FDE]' : undefined}
            className="h-full w-full"
          />
        </div>
      )}
      {title}
    </button>
  );
};
